import { formatDate } from '@angular/common';
import { Component, computed, ElementRef, input, output, signal, viewChild } from '@angular/core';
import { ColDef, GridOptions } from 'ag-grid-community';
import { defaultTableDefOptions } from 'src/app/helpers';
import { TimelineRow } from 'src/app/types';

@Component({
  selector: 'app-incident-timeline-table',
  templateUrl: './incident-timeline-table.component.html',
  styleUrls: ['./incident-timeline-table.component.scss'],
  standalone: false,
})
export class IncidentTimelineTableComponent {
  rows = input.required<TimelineRow[]>();
  showViewMore = input<boolean>(false);
  noMoreData = input<boolean>(false);
  isLoading = input<boolean>(false);

  viewMore = output<void>();

  container = viewChild<ElementRef<HTMLDivElement>>('gridContainer');
  maxHeight = signal<number | undefined>(undefined);

  onViewMoreClick() {
    const container = this.container();
    if (!container) return;
    this.maxHeight.set(container.nativeElement.offsetHeight);
    this.viewMore.emit();
  }

  private readonly columnDefs: ColDef[] = [
    {
      headerName: 'When',
      field: 'when',
      maxWidth: 200,
    },
    {
      headerName: 'Transaction ID',
      field: 'transactionId',
      cellDataType: 'text',
      wrapText: true,
      autoHeight: true,
      cellStyle: { 'word-break': 'break-all' },
    },
    {
      headerName: 'Date/time',
      field: 'timestamp',
      maxWidth: 300,
      wrapText: true,
      autoHeight: true,
      valueFormatter: (params) => {
        if (!params.value) return '';
        return formatDate(params.value, 'MM/dd/yyyy hh:mm:ss a', 'en-US');
      },
    },
    {
      headerName: 'Items',
      field: 'items',
      autoHeight: true,
      cellRenderer: (params) => {
        if (!params.value) return '';
        return `<div class="whitespace-pre-wrap">${params.value}</div>`;
      },
    },
  ];

  tableDef = computed<GridOptions>(() => ({
    ...defaultTableDefOptions(),
    columnDefs: this.columnDefs,
    onGridReady: ({ api }) => api.sizeColumnsToFit(),
    onGridSizeChanged: ({ api }) => api.sizeColumnsToFit(),
    getRowClass: ({ data }) => (data?.highlight ? 'highlight-row' : ''),
  }));
}
